import React from 'react'

type Props = {
	onBack: () => void
	onNext: () => void
	backDisabled?: boolean
	nextDisabled?: boolean
	nextLabel?: string
	nextStepLabel?: string
}

interface FooterProps {
	openModal: () => void
	//formRef: React.RefObject<HTMLFormElement>
}

export default function WizardFooter({
	onBack,
	onNext,
	backDisabled = false,
	nextDisabled = false,
	nextLabel = 'Avanti',
	nextStepLabel,
}: Props) {
	return (
		<>
			<footer
				className='sticky bottom-0 z-50 bg-white
                shadow-[0px_-4px_20px_0px_#0000000D]
                py-4 md:py-6 w-full'
			>
				<div className='max-w-[1296px] mx-auto px-3 md:px-6'>
					<div className='flex items-center justify-between gap-4'>
						<button
							className='
                                bg-white
                                text-[16px] text-(--green-default)
                                border-[3px]
                                font-bold
                                px-4 md:px-4
                                py-2
                                rounded-[30px]
                                transition cursor-pointer
                                hover:underline
                                hover:bg-(--disabled)
                            '
							//   onClick={openModal}
						>
							Salva Bozza
						</button>

						<button
							type='button'
							onClick={onNext}
							disabled={nextDisabled}
							className={`font-bold px-5 md:px-4 py-3 md:py-2 rounded-[30px] transition
                                ${
																	!nextDisabled
																		? `text-base font-bold text-white
                                        leading-6
                                        bg-(--green-default)
                                        bg-linear-to-r from-(--green-default) to-(--green-hover)
                                        shadow-[0_3px_10px_rgba(0,0,0,0.1)]
                                        cursor-pointer transition-colors duration-300
                                        hover:from-(--brand-green) hover:to-(--brand-green)
                                        hover:underline
                                        active:bg-(--brand-green)
                                        active:scale-95
                                        active:underline`
																		: 'text-(--border-top) bg-(--disabled) cursor-not-allowed'
																}
                            `}
						>
							Prosegui
						</button>
					</div>

					{nextStepLabel && (
						<div className='border-t-[0.5px] border-(--border-top) pt-4 mt-4'>
							<div className='flex flex-col md:flex-row items-center justify-center gap-1 md:gap-6 text-center'>
								<p className='text-[12px] font-semibold'>Prossimo step</p>
								<p className='text-[12px]'>{nextStepLabel}</p>
							</div>
						</div>
					)}
				</div>
			</footer>
		</>
	)
}
